// extracted by mini-css-extract-plugin
module.exports = {"cardsWrapper":"CardBanner_cardsWrapper__2Hoce","image":"CardBanner_image__BV4Yn","row":"CardBanner_row__13SLL","children":"CardBanner_children__m-7d1"};